var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTotalassetsyeargrowth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance and payment/outline/gold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 848",
    d: "M8.39225 8.15257C8.55313 7.47687 9.15686 7 9.85145 7H14.1485C14.8431 7 15.4469 7.47687 15.6078 8.15257L16.5601 12.1526C16.7846 13.0951 16.0698 14 15.1009 14H8.89907C7.93016 14 7.21544 13.0951 7.43986 12.1526L8.39225 8.15257Z",
    stroke: "#F96895",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 849",
    d: "M3.39225 15.1526C3.55313 14.4769 4.15686 14 4.85145 14H9.14855C9.84314 14 10.4469 14.4769 10.6078 15.1526L11.5601 19.1526C11.7846 20.0951 11.0698 21 10.1009 21H3.89907C2.93016 21 2.21544 20.0951 2.43986 19.1526L3.39225 15.1526Z",
    stroke: "#F96895",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 850",
    d: "M13.3922 15.1526C13.5531 14.4769 14.1569 14 14.8515 14H19.1485C19.8431 14 20.4469 14.4769 20.6078 15.1526L21.5601 19.1526C21.7846 20.0951 21.0698 21 20.1009 21H13.8991C12.9302 21 12.2154 20.0951 12.4399 19.1526L13.3922 15.1526Z",
    stroke: "#F96895",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2119",
    d: "M12 3V4",
    stroke: "#F96895",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2121",
    d: "M18 4L17 5",
    stroke: "#F96895",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2122",
    d: "M6 4L7 5",
    stroke: "#F96895",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTotalassetsyeargrowth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/totalassetsyeargrowth.047556ff901064dfb92ef3ca18afa7fb.svg";